'use strict'

import { loadComponent } from './utils/load-component';

const pageLocationClasses = {
    '': 'theme-blue',
    'Events Only': 'theme-purple',
    'Tours Only': 'theme-orange',
}

loadComponent(
    'calendar-filter',
    {
        props: [],
        data: function () {
            return {
                ViewModel: {
                    Groups: [],
                },
                selectedLocation: '',
                filters: {},
            };
        },
        methods: {
            clearForm: function () {
                Object.keys(this.filters).forEach(key => {
                    this.filters[key] = [];
                });
                this.filterChanged();
            },
            filterChanged: function () {
                this.$root.$emit('CalendarFilters.filtersUpdated', this.filters);
            },
            updateFilters: function (filters) {
                // Pass updated Filters from CalendarList?
                this.ViewModel.Groups = filters;
                this.filters = filters.reduce((carry, filter) => {
                    carry[filter.ID] = [];
                    return carry;
                }, {});
            },
            updateAppliedFilters: function (filters) {
                Object.keys(this.filters).forEach(key => {
                    this.filters[key] = key in filters ? filters[key] : [];
                });
            },
            updateLocation() {
                this.updateBackground();
                this.updateUrlParam();
                this.$root.$emit('CalendarFilters.locationUpdated', this.selectedLocation);
            },
            updateBackground() {
                if (this.globalContainer) {
                    const targetTheme = pageLocationClasses[this.selectedLocation];

                    this.globalContainer.classList.remove('theme-orange', 'theme-purple', 'theme-blue');

                    if (targetTheme) {
                        this.globalContainer.classList.add(targetTheme);
                    }
                }
            },
            updateUrlParam() {
                const urlParams = new URLSearchParams(window.location.search);

                const reverseLocationMap = {
                    'Tours Only': 'tour',
                    'Events Only': 'events',
                    '': ''
                };

                const paramValue = reverseLocationMap[this.selectedLocation];

                if (paramValue) {
                    urlParams.set('location', paramValue);
                } else {
                    urlParams.delete('location');
                }

                const newUrl = urlParams.toString()
                    ? `${window.location.pathname}?${urlParams.toString()}`
                    : window.location.pathname;

                window.history.replaceState({}, '', newUrl);
            },
            initializeFromUrlParams() {
                const urlParams = new URLSearchParams(window.location.search);
                const locationParam = urlParams.get('location');

                const locationMap = {
                    'tour': 'Tours Only',
                    'events': 'Events Only'
                };

                if (locationParam && locationMap[locationParam]) {
                    this.selectedLocation = locationMap[locationParam];
                    this.updateLocation();
                }
            }
        },
        beforeMount: function () {
            this.$root.$on('CalendarFilter.updateFilters', this.updateFilters);
            this.$root.$on('CalendarFilter.updateAppliedFilters', this.updateAppliedFilters);
            this.$root.$on('CalendarFilters.clearFilters', this.clearForm);
        },
        mounted: function () {
            this.globalContainer = document.querySelector('.global-container');
            this.updateBackground();

            this.initializeFromUrlParams();
        }
    }
)
